import React from "react";
import { Row, Col, Button } from 'react-bootstrap';
function Overview() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <h2>1st Convocation  - Updates</h2>


            <Row className='mb-5  mt-5'>

                <Col md={2} className="mb-3">

                    <span className="c-date">
                        Aug <br /> 13
                    </span>

                </Col>

                <Col md={10} className="mb-3 text-left">
                    <span> First Convocation - 2019 at Yerpedu Campus</span>
                </Col>
            </Row>
            <h4> <a className="c-link" href="https://files.iittp.ac.in/pdfs/convocation/2019/Brochure-2019.pdf">Convocation Brochure - 2019 </a></h4>
        </div>


    );
}

export default Overview;
